module.exports = __webpack_public_path__ + "static/img/mingtai_icon.be87ad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/mingtai_icon.png
// module id = emwG
// module chunks = 1